import { render, staticRenderFns } from "./EventableEntityCard.vue?vue&type=template&id=e372e878&scoped=true&"
import script from "./EventableEntityCard.vue?vue&type=script&lang=js&"
export * from "./EventableEntityCard.vue?vue&type=script&lang=js&"
import style0 from "./EventableEntityCard.vue?vue&type=style&index=0&id=e372e878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e372e878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VDivider,VIcon,VTooltip})
